import categorieEquipementTypes from "./categorieEquipement.types";

interface ICategorieEquipementReducerState {
  list: any,
  itemSelected: any,
  loading: boolean,
  error: string
}

const INITIAL_STATE = {
  list: [],
  itemSelected: {},
  loading: false,
  error: ""
};

const categorieEquipementReducer = (
  state: ICategorieEquipementReducerState = INITIAL_STATE,
  action: any
): ICategorieEquipementReducerState => {
  switch (action.type) {
    case categorieEquipementTypes.GET_CATEGORIE_EQUIPEMENT_LIST:
      return {
        ...state,
        list: action.payload,
        error: ""
      };

    case categorieEquipementTypes.SELECTED_CATEGORIE_EQUIPEMENT:
      return {
        ...state,
        itemSelected: action.payload,
        error: ""
      };
    
    case categorieEquipementTypes.LOADING:
      return {
        ...state,
        loading: action.payload,
        error: ""
      };

    default:
      return state;
  }
};

export default categorieEquipementReducer;
